export const MENUITEMS = [
  {
    Items: [
      {
        path: `/race?type=f1`,
        icon: "ti ti-car",
        type: "link",
        active: false,
        selected: false,
        title: "Race F1",
      },
      {
        path: `/race?type=moto_gp`,
        icon: "ti ti-car",
        type: "link",
        active: false,
        selected: false,
        title: "Race MotoGP",
      },
      {
        path: `/colorcode?type=f1`,
        icon: "fas fa-palette",
        type: "link",
        active: false,
        selected: false,
        title: "Colorcode F1",
      },
      {
        path: `/colorcode?type=moto_gp`,
        icon: "fas fa-palette",
        type: "link",
        active: false,
        selected: false,
        title: "Colorcode MotoGP",
      },
      {
        path: `/user`,
        icon: "si si-user",
        type: "link",
        active: false,
        selected: false,
        title: "UserList",
      },
      {
        path: `/standing?type=f1`,
        icon: "fa fa-users",
        type: "link",
        active: false,
        selected: false,
        title: "Standing F1",
      },
      {
        path: `/standing?type=moto_gp`,
        icon: "fa fa-users",
        type: "link",
        active: false,
        selected: false,
        title: "Standing MotoGP",
      },
      {
        path: `/seasons?type=f1`,
        icon: "fa fa-solid fa-cloud",
        type: "link",
        active: false,
        selected: false,
        title: "Seasons F1",
      },
      {
        path: `/seasons?type=moto_gp`,
        icon: "fa fa-solid fa-cloud",
        type: "link",
        active: false,
        selected: false,
        title: "Seasons MotoGP",
      },
      {
        path: `/seasonlist?type=f1`,
        icon: "fa fa-solid fa-list-ul",
        type: "link",
        active: false,
        selected: false,
        title: "SeasonsList F1",
      },
      {
        path: `/seasonlist?type=moto_gp`,
        icon: "fa fa-solid fa-list-ul",
        type: "link",
        active: false,
        selected: false,
        title: "SeasonsList MotoGP",
      },
      {
        path: `/groups`,
        icon: "fas fa-solid fa-layer-group",
        type: "link",
        active: false,
        selected: false,
        title: "Group",
      },
      // {
      //   path: `/groups?type=moto_gp`,
      //   icon: "fas fa-solid fa-layer-group",
      //   type: "link",
      //   active: false,
      //   selected: false,
      //   title: "Groups MotoGP",
      // },
      {
        path: `/highscore?type=f1`,
        icon: "fas fa-star",
        type: "link",
        active: false,
        selected: false,
        title: "High Score F1",
      },
      {
        path: `/highscore?type=moto_gp`,
        icon: "fas fa-star",
        type: "link",
        active: false,
        selected: false,
        title: "High Score MotoGP",
      },
      {
        path: `/countrylist`,
        icon: "fas fa-flag",
        type: "link",
        active: false,
        selected: false,
        title: "Country",
      },
      {
        path: `/countrycode`,
        icon: "fas fa-phone",
        type: "link",
        active: false,
        selected: false,
        title: "Country Code",
      },
      {
        path: `/setting?type=f1`,
        icon: "fas fa-gear",
        type: "link",
        active: false,
        selected: false,
        title: "Settings F1",
      },
      {
        path: `/setting?type=moto_gp`,
        icon: "fas fa-gear",
        type: "link",
        active: false,
        selected: false,
        title: "Settings MotoGP",
      },
      {
        path: `/feedback`,
        icon: "fa fa-comment",
        type: "link",
        active: false,
        selected: false,
        title: "Feedback",
      },
      {
        path: `/notification?type=common`,
        icon: "fa fa-bell",
        type: "link",
        active: false,
        selected: false,
        title: "Notification",
      },
      {
        path: `/notification?type=predict`,
        icon: "fa fa-bell",
        type: "link",
        active: false,
        selected: false,
        title: "Predict Notification",
      },
    ],
  },
];
